import React from 'react';

import Message from '@xingternal/malt-message';
import { testable } from '@xingternal/malt-util';
import { QA_MALT } from '@xingternal/malt-constants';

import Spacer from './../../Components/Spacer/Spacer';

const FormMessage = ({ notice, error }) => {
  const type = error ? 'error' : 'information';
  const message = error || notice;

  const TestableMessageContainer = testable(QA_MALT, 'div');

  if (!message) return null;

  return (
    <TestableMessageContainer testId={`message-${type}`}>
      <Message type={type} small>
        {message}
      </Message>
      <Spacer size={6} />
    </TestableMessageContainer>
  );
};

export default FormMessage;
